<template>
  <div>
    <p v-if="!hasChatUnblockId">
      chat unblock id unknown
    </p>
    <player-chat-unblock-link
      v-if="hasChatUnblockId"
      :playerId="action.playerId"
      :chatUnblockId="action.chatUnblockId"
      lable="chat unblock"
    />
  </div>
</template>

<script>
import PlayerChatUnblockLink from './PlayerChatUnblockLink.vue';

export default {
  name: 'UserActionInfoUnblockChat',

  components: {
    PlayerChatUnblockLink,
  },

  props: {
    action: {
      type: Object,
      required: true,
    }
  },

  computed: {
    hasChatUnblockId() {
      return 'chatUnblockId' in this.action;
    },
  },
};
</script>
